import { Pipe, PipeTransform } from "@angular/core";
import { ObjectUtils } from "../utils/object-utils";

@Pipe({ name: "raskFordelning" })
export class FordelningPipe implements PipeTransform {

    transform(value: unknown, ...args: unknown[]): unknown {

        if (ObjectUtils.isNullOrUndefined(value)) {
            return "";
        }
        return `${value}%`;
    }
}
